import { Typography, Box } from "@mui/material";

const FormLabel = ({ label, fontSize = "16px", fontWeight = 500, required = false }) => {
    return (
        <Typography
            variant="h6"
            sx={{
                fontSize: fontSize,
                fontWeight: fontWeight,
                mb: 0.5,
            }}
        >
            {label}
            {required && (
                <Box component="span" sx={{ color: "error.main", ml: 0.5 }}>
                    *
                </Box>
            )}
        </Typography>
    );
};

export default FormLabel;
